import React from 'react';
import { Tune } from '@mui/icons-material';

import styles from './FilterFab.module.scss';

interface FilterFabProps {
  onClick: () => void;
}

const FilterFab: React.FC<FilterFabProps> = ({ onClick }) => {
  return (
    <button
      type='button'
      className={styles.fab}
      onClick={onClick}
      aria-label='Open advanced filters'>
      <Tune fontSize='small' />
    </button>
  );
};

export default FilterFab;
